import { FadeIn, Spinner } from './Animations';
import { cn } from './cn';

export interface LoaderProps {
  label?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

// `px` repeats each `svg` class as a presentation attribute, so the intended size holds even where the
// utility stylesheet is absent. Keep the two in step: 4/6/8 are rem-quarters, so 16/24/32 pixels.
const sizeConfig = {
  sm: { svg: 'h-4 w-4', px: 16, stroke: 3, gap: 'gap-1.5', padding: 'py-2', text: 'text-xs' },
  md: { svg: 'h-6 w-6', px: 24, stroke: 3, gap: 'gap-2', padding: 'py-6', text: 'text-sm' },
  lg: { svg: 'h-8 w-8', px: 32, stroke: 4, gap: 'gap-3', padding: 'py-12', text: 'text-sm' },
};

export const Loader = ({ label, className, size = 'lg' }: LoaderProps) => {
  const config = sizeConfig[size];

  return (
    <FadeIn className={cn('flex items-center justify-center', config.gap, config.padding, className)}>
      <Spinner
        className={cn(config.svg)}
        data-test="loader-spinner"
        width={config.px}
        height={config.px}
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" className="text-primary-200" strokeWidth={config.stroke} />
        <path
          d="M22 12a10 10 0 00-10-10"
          stroke="currentColor"
          className="text-primary-500"
          strokeWidth={config.stroke}
          strokeLinecap="round"
        />
      </Spinner>
      {label && (
        <FadeIn className={cn('text-gray-500', config.text)} transition={{ delay: 0.2 }}>
          {label}
        </FadeIn>
      )}
    </FadeIn>
  );
};
